import {
  ApiResponse,
  CashDiscountGrouped,
  CreateDiscount,
  TokenData,
  CashDiscount,
  OtpResponse,
  CreateDiscountLimits,
  CreateCampaignDiscountGroup,
  CampaignCashDiscount,
  CreateCampaignCashDiscountLimits,
} from '../models';
import * as http from './http';
import ApiService from './service';

export class CampaignCashDiscountService extends ApiService {
  public async loadCashDiscountType() {
    const url = `${this.apiDomain}/api/discount/cash`;

    const resposne = await http.get<ApiResponse<CashDiscountGrouped>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async createDiscount(data: CreateCampaignDiscountGroup, id?: string) {
    const url = `${this.apiDomain}/api/campaign/${id}/add-discount`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      { ...data, discountType: 'Cash_Discount' },
      this.store
    );
    return response.data;
  }

  public async updateDiscount(data: CreateCampaignDiscountGroup, id?: string) {
    const url = `${this.apiDomain}/api/campaign/${id}/update-add-discount`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      { ...data, discountType: 'Cash_Discount' },
      this.store
    );
    return response.data;
  }

  public async getCashDiscount(id: string) {
    const url = `${this.apiDomain}/api/campaign/cash-discount/${id}`;

    const resposne = await http.get<ApiResponse<CampaignCashDiscount>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }

  public async requestOtp(purpose?: string, requestType?: string) {
    const url = `${this.apiDomain}/api/otp/request`;

    const response = await http.post<ApiResponse<OtpResponse>>(
      url,
      {
        purpose: purpose || 'Confirm Discount Request',
        requestType,
      },
      this.store
    );
    return response.data;
  }
  public async reSendOtp(id?: string, purpose?: string, requestType?: string) {
    const url = `${this.apiDomain}/api/otp/${id}/resend`;

    const response = await http.put<ApiResponse<OtpResponse>>(
      url,
      {
        purpose: purpose || 'Confirm Discount Request',
        requestType,
      },
      this.store
    );
    return response.data;
  }

  public async updateCashDiscountLimits(
    data?: CreateCampaignCashDiscountLimits,
    id?: string
  ) {
    const url = `${this.apiDomain}/api/campaign/edit/${id}/cash-discount`;

    const response = await http.put<ApiResponse<CampaignCashDiscount>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async cloneDiscount(data: CreateDiscount, id?: string) {
    const url = `${this.apiDomain}/api/discount/cash/${id}/clone`;

    const response = await http.post<ApiResponse<CashDiscount>>(
      url,
      data,
      this.store
    );
    return response?.data?.data;
  }

  public async deleteDiscount(id?: string) {
    const url = `${this.apiDomain}/api/campaign/cash/${id}`;
    const response = await http.remove<ApiResponse<CampaignCashDiscount>>(
      url,
      this.store
    );
    return response?.data?.data;
  }
}
